import { useState } from 'react';

export default function LoginScreen({ onAuthenticated }) {
  const [pin, setPin]       = useState('');
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ pin }),
      });
      if (res.ok) {
        onAuthenticated();
      } else {
        setError('Wrong PIN — try again');
        setPin('');
      }
    } catch {
      setError('Cannot reach server');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0f172a',
      padding: 24,
    }}>
      <div style={{
        background: '#1e293b',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 20,
        padding: '44px 36px',
        width: '100%',
        maxWidth: 360,
        boxShadow: '0 24px 64px rgba(0,0,0,0.5)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontSize: 44, marginBottom: 14, lineHeight: 1 }}>⚡</div>
          <h1 style={{
            fontSize: 22, fontWeight: 700, color: '#f1f5f9',
            letterSpacing: '-0.5px', margin: 0,
          }}>
            Taha HQ
          </h1>
          <p style={{ fontSize: 13, color: '#475569', marginTop: 8, marginBottom: 0 }}>
            Enter your PIN to continue
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            inputMode="numeric"
            placeholder="• • • •"
            value={pin}
            onChange={e => setPin(e.target.value)}
            autoFocus
            style={{
              width: '100%',
              background: 'rgba(0,0,0,0.3)',
              border: `1px solid ${error ? 'rgba(248,113,113,0.5)' : 'rgba(255,255,255,0.1)'}`,
              borderRadius: 12,
              padding: '14px 16px',
              fontSize: 22,
              letterSpacing: '0.35em',
              color: '#f1f5f9',
              textAlign: 'center',
              outline: 'none',
              boxSizing: 'border-box',
              marginBottom: 12,
              transition: 'border-color 0.15s',
            }}
          />

          {error && (
            <div style={{
              fontSize: 12, color: '#f87171', textAlign: 'center',
              marginBottom: 12, padding: '9px 12px',
              background: 'rgba(248,113,113,0.1)',
              borderRadius: 8, border: '1px solid rgba(248,113,113,0.2)',
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !pin}
            style={{
              width: '100%',
              background: loading || !pin
                ? 'rgba(255,255,255,0.05)'
                : 'linear-gradient(135deg, #6366f1, #8b5cf6)',
              color: loading || !pin ? '#334155' : '#fff',
              border: 'none',
              borderRadius: 12,
              padding: '14px',
              fontSize: 14,
              fontWeight: 600,
              cursor: loading || !pin ? 'not-allowed' : 'pointer',
              boxShadow: loading || !pin ? 'none' : '0 4px 16px rgba(99,102,241,0.4)',
              transition: 'all 0.15s',
            }}
          >
            {loading ? 'Checking…' : 'Unlock'}
          </button>
        </form>
      </div>
    </div>
  );
}
